import { ActivitySubjects } from "@outschool/business-rules";

import { SubCategoryType } from "../TutoringConstants";

export const PAGE_LOCATION = "TUTORING_LANDING_PAGE";

export type subject = ActivitySubjects.ActivitySubject;
export type SubCategoryWithSubject = SubCategoryType & { subject: subject };

export const TUTORING_CATEGORY = "tutoring";
